<template>
  <div>
    <van-nav-bar
        :title="title"
    >
      <template #title>
        <slot>正云人工智能DEMO</slot>
      </template>
      <template #left>
        <slot name="left">
          <van-icon name="arrow-left" color="#333333" @click="onBack" />
        </slot>
      </template>
      <template #right>
        <slot name="right">
        </slot>
      </template>
    </van-nav-bar>
  </div>
</template>

<script>
  import {Button, Cell, CellGroup, NavBar, Icon, Popup, RadioGroup, Radio, Field} from "vant";
  export default {
    name: 'MyHeader',
    components: {
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [NavBar.name]: NavBar,
      [Icon.name]: Icon,
      [Popup.name]: Popup,
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio,
      [Field.name]: Field,
      [Button.name]: Button
    },
    data () {
      return {
        menuShow: false,
        lang: ''
      }
    },
    props: {
      title: {
        type: String,
        default: '棠棣兰花'
      },
      leftClick: [Function, Boolean]
    },
    watch:{
    },
    methods: {
      LangChange(lang) {
        this.$store.dispatch('app/setLang', lang).then(res => {
          this.$i18n.locale = lang
        })
      },
      onBack() {
        if(this.leftClick){
          this.leftClick()
        }else{
          this.$router.back()
        }
      }
    },
    mounted() {
      // console.log(this.$store.state.app)
    }
  }
</script>

<style scoped>

</style>
